export default class H {
  constructor(t = !1, s = []) {
    (this.W = t), (this.Ee = s), (this.W = t), (this.Ee = s);
  }
  Yt(t) {
    (this.W = this.W && t.W), this.Ee.push(...t.Ee);
  }
}
